import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { MobileHelper } from 'src/app/core/helpers/mobile-helper';

@Injectable({
  providedIn: 'root',
})
export class MobileSigneringGuard implements CanActivate {
  constructor(private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const isMobile = MobileHelper.isMobile();
    if (isMobile) {
      this.router.navigate(['digitalsigneringmobile', next.params.ticket]);
    }
    return true;
  }
}
